export const useOfflinePosConnectivity = () =>
	useState("offline-pos:online", () =>
		process.client ? navigator.onLine : true
	)
